import { Auth, CognitoUser } from '@aws-amplify/auth'
import { Auth as AuthService, AuthAttributes, Provider } from './Auth'

interface ExtendedCognitoUser extends CognitoUser {
  challengeParam:
    | {
        CODE_DELIVERY_DESTINATION: string
      }
    | undefined
}

interface SignUpResponse {
  userSub: string
}

export const AuthCognito: AuthService = {
  signIn: async (username: string, password: string) => {
    const user: ExtendedCognitoUser = await Auth.signIn(username, password)
    return {
      challenge: user.challengeName === 'SMS_MFA' ? 'SMS_MFA' : undefined,
      challengePhoneNumber: user.challengeParam?.CODE_DELIVERY_DESTINATION,
      cognitoUser: user,
    }
  },

  signUp: async (attributes: AuthAttributes) => {
    const { userSub }: SignUpResponse = await Auth.signUp(attributes)
    return { userSub }
  },

  signOut: async (global: boolean) => {
    await Auth.signOut({ global })
  },

  confirmSignIn: async (user: CognitoUser, code: string) => {
    await Auth.confirmSignIn(user, code, 'SMS_MFA')
  },

  confirmSignUp: async (email: string, code: string) => {
    await Auth.confirmSignUp(email, code)
  },

  resendSignUpCode: async (email: string) => {
    await Auth.resendSignUp(email)
  },

  forgotPassword: async (email: string) => {
    await Auth.forgotPassword(email)
  },

  forgotPasswordSubmit: async (email: string, code: string, password: string) => {
    await Auth.forgotPasswordSubmit(email, code, password)
  },

  federatedSignIn: async (provider: Provider) => {
    await Auth.federatedSignIn({ customProvider: provider })
  },
}
